'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIcon = require('./util/createIcon');

var _createIcon2 = _interopRequireDefault(_createIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createIcon2.default)('M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z');


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-material-ui/ChevronUp.js
// module id = 1184
// module chunks = 1 2